// WHY: sits below the scroll-independent sticky bulk-actions bar
const PANE_TOP_PX = 192;
const SCREEN_BOTTOM_GAP_PX = 32;
const SCREEN_RIGHT_GAP_PX = 24;
const PANE_WIDTH_PX = 482;
export const BULK_PANE_INTERCOM_VERTICAL_PADDING = 100;
export const bulkPanePosition = {
    top: 'auto',
    bottom: "".concat(SCREEN_BOTTOM_GAP_PX, "px"),
    right: "".concat(SCREEN_RIGHT_GAP_PX, "px"),
    width: "".concat(PANE_WIDTH_PX, "px"),
    height: "calc(100vh - ".concat(PANE_TOP_PX, "px - ").concat(SCREEN_BOTTOM_GAP_PX, "px)")
};
